// frontend/src/tour/steps/search-leads.steps.js
export const SEARCH_LEADS_TOUR_STEPS = (role) => {
  // Normalize role name
  const normalizedRole = normalizeRole(role);
  
  const steps = [
    {
      id: "search-leads-welcome",
      selector: "body",
      placement: "center",
      copy: {
        Admin: {
          title: "Welcome to Search Leads",
          content:
            "Use this page to search and filter leads across all territories. Search by address or customer name, refine by first/last name, street, zip, or phone, and apply filters to narrow results.",
        },
        Manager: {
          title: "Welcome to Search Leads",
          content:
            "Search and filter leads across your territories. Use the search bar to find specific leads, or apply filters to view leads by status, territory, rep, or property type.",
        },
        "Sales Rep": {
          title: "Welcome to Search Leads",
          content:
            "Search through leads assigned to you. Use the search bar to find specific leads quickly, or apply filters to organize your view.",
        },
      },
    },
    {
      id: "search-bar",
      selector: '[data-tour="search-bar"]',
      placement: "bottom",
      copy: {
        Admin: {
          title: "Search Bar",
          content:
            "Type here to search by street address or customer name. Address matches come first. Use Refine Search for first name, last name, street, zip, or phone.",
        },
        Manager: {
          title: "Search Bar",
          content:
            "Use this search bar to find leads by address or customer name. Results update as you type. Open Refine Search for more precise fields.",
        },
        "Sales Rep": {
          title: "Search Bar",
          content:
            "Search for leads by address or customer name. Use Refine Search when you want to match first name, last name, street, zip, or phone.",
        },
      },
    },
    {
      id: "filter-toggle",
      selector: '[data-tour="filter-toggle"]',
      placement: "bottom",
      copy: {
        Admin: {
          title: "Advanced Filters",
          content:
            "Click 'Show Filters' to access advanced filtering options. You can filter by status, territory, assigned rep, property type, and date ranges. The badge shows how many filters are currently active.",
        },
        Manager: {
          title: "Advanced Filters",
          content:
            "Use the 'Show Filters' button to access filtering options. Filter leads by status, territory, assigned rep, property type, or date ranges. The number badge shows active filters.",
        },
        "Sales Rep": {
          title: "Advanced Filters",
          content:
            "Click 'Show Filters' to reveal additional filtering options. Filter your leads by status, territory, property type, or date ranges.",
        },
      },
    },
    {
      id: "results-table",
      selector: '[data-tour="results-table"]',
      placement: "top",
      copy: {
        Admin: {
          title: "Results Table",
          content:
            "This table displays all matching leads. Click any row to view that lead's details. The table shows name, contact info, status, territory, assigned rep, and creation date. Use pagination at the bottom to navigate through multiple pages of results.",
        },
        Manager: {
          title: "Results Table",
          content:
            "View all matching leads in this table. Click any row to see detailed lead information. Use the pagination controls to navigate through results.",
        },
        "Sales Rep": {
          title: "Results Table",
          content:
            "Your search results appear here. Click any lead row to view its details. Use pagination to navigate through multiple pages of results.",
        },
      },
    },
  ];

  // Resolve steps based on role
  return steps.map((step) => {
    const roleCopy = step.copy[normalizedRole] || step.copy["Sales Rep"];
    
    return {
      selector: step.selector,
      placement: step.placement,
      title: roleCopy.title,
      content: roleCopy.content,
    };
  });
};

// Helper function to normalize role names
function normalizeRole(role) {
  if (!role) return "Sales Rep";
  const roleLower = role.toLowerCase();
  if (roleLower.includes("admin")) return "Admin";
  if (roleLower.includes("director")) return "Admin"; // Sales Director uses Admin copy
  if (roleLower.includes("manager")) return "Manager";
  return "Sales Rep";
}

/**
 * Versioned "new only" tour for Search Leads.
 * Add steps here when you ship new features; bump the key (e.g. v1_7_search_leads_new_complete) when you add more.
 */
export const SEARCH_LEADS_NEW_STEPS = () => [];